import styles from "./Loader.module.css"
import GWhiteLoader from "../../utils/assets/images/Loader/G_WhiteLoader.svg"
import GGreenLoader from "../../utils/assets/images/Loader/G_GreenLoader.svg"
import Image from "next/image"
import { Box, BoxProps } from "@mui/material"

const GLoader = (props: BoxProps) => {
  return (
    <Box className={styles.GLoader} {...props}>
      <div className={styles.GLoaderWhite}>
        <Image src={GWhiteLoader} alt={"G"} width={25} height={25} />
      </div>
      <div className={styles.GLoaderGreen}>
        <Image src={GGreenLoader} alt={"G"} width={25} height={25} />
      </div>
    </Box>
  )
}

export default GLoader
